export default __webpack_public_path__ + "static/media/SS1-min.fa56095c.png";